class ActionLists {
  constructor() {
    const rideActions = [
      { title: "Mark as cancelled", name: "markAsCancelled", resource: "Ride" },
      { title: "Assign captain", name: "assignCaptain", resource: "Ride" },
      {
        title: "Create Invoice Item",
        name: "createRideInvoiceItem",
        resource: "InvoiceItem",
      },
    ];

    const captainTransactionActions = [
      { title: "Copy transaction ID", name: "copyTransactionId", isCopy: true },
    ];

    const customerTransactionActions = [
      { title: "Copy transaction ID", name: "copyTransactionId", isCopy: true },
      // { title: 'Refund Transactions', name: 'refundTransaction', resource: 'Transaction' }
    ];

    const corporateActions = [
      { title: "Remove Seat", name: "removeSeat", resource: "Subscription" },
      {
        title: "Unassign Seat",
        name: "unassignSeat",
        resource: "Subscription",
      },
      { title: "Assign Seat", name: "assignSeat", resource: "Subscription" },
    ];

    const bookingActions = [
      {
        title: "Check in booking",
        name: "checkInBooking",
        resource: "Bookings",
        strict: ["booked", "missed"],
      },
      {
        title: "Check out booking",
        name: "checkOutBooking",
        resource: "Bookings",
        strict: ["checked_in"],
      },
      {
        title: "Pay",
        name: "pay",
        resource: "Bookings",
        strict: ["checked_in", "paid"],
      },
      {
        title: "Cancel & Refund",
        name: "cancelRefund",
        resource: "Bookings",
        strict: ["booked"],
      },
      {
        title: "Refund",
        name: "refund",
        resource: "Bookings",
        strict: ["missed", "cancelled"],
      },
      {
        title: "Rebook",
        name: "rebook",
        resource: "Bookings",
        strict: ["missed", "cancelled"],
      },
    ];

    const captainFinanceActions = [
      { title: "List Invoices", name: "goToInvoices" },
    ];

    const invoiceItemActions = [
      {
        title: "Deactivate Invoice Item",
        name: "deactivateInvoiceItem",
        resource: "InvoiceItem",
      },
      {
        title: "Activate Invoice Item",
        name: "activateInvoiceItem",
        resource: "InvoiceItem",
      },
      {
        title: "Add Note",
        name: "addInvoiceItemNote",
        resource: "InvoiceItem",
      },
    ];

    const userPromotionsActions = [
      {
        title: "Remove User",
        name: "removeUserPromotion",
        resource: "Userpromotion",
      },
    ];

    const corporateInvoiceItemActions = [
      {
        title: "Deactivate Invoice Item",
        name: "deactivateCorporateInvoiceItem",
        resource: "Corporate",
      },
      {
        title: "Activate Invoice Item",
        name: "activateCorporateInvoiceItem",
        resource: "Corporate",
      },
      {
        title: "Add Note",
        name: "addCorporateInvoiceItemNote",
        resource: "Corporate",
      },
    ];

    this.all = {
      rideActions,
      captainTransactionActions,
      customerTransactionActions,
      bookingActions,
      corporateActions,
      captainFinanceActions,
      invoiceItemActions,
      userPromotionsActions,
      corporateInvoiceItemActions,
    };
  }
}

export default ActionLists;



// WEBPACK FOOTER //
// ./src/services/actionLists/actionLists.service.js